
import Config from './config';

export default class Request extends Config {

    get endpint() {
        return 'https://api.github.com/graphql'
    }

    async fetch( query ) {
        return await fetch( this.endpint, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${ this.token }`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query }),
        })
    }
}